import {DICTIONARY} from "%modules%/translate/dictionary";

let lang = 'am';
// localStorage.setItem('lang', lang);
// setLang(lang);

if (document.querySelector(`[data-lang="${lang}"]`)) {
    $('.js-lang-button').removeClass('language__item_active');
    document.querySelector(`[data-lang="${lang}"]`).classList.add('language__item_active');
}


if ($('.js-lang-button')) {
    $('.js-lang-button').on('click', clickLangButtonHandler)
}


function setLang(lang){
    if( window.hasOwnProperty('localStorage')) {
        window.localStorage.setItem('lang', lang);
    }

    for (let word in DICTIONARY) {
        if (document.querySelector(`[data-text-item="${word}"]`)) {
            document.querySelector(`[data-text-item="${word}"]`).innerHTML = DICTIONARY[word][lang];
        }
        if (document.querySelector(`[data-placeholder="${word}"]`)) {
            document.querySelector(`[data-placeholder="${word}"]`).placeholder = DICTIONARY[word][lang];
        }

    }
}

function clickLangButtonHandler () {
    $('.js-lang-button').removeClass('language__item_active');
    $(this).addClass('language__item_active');
    const lang = $(this).attr('data-lang');
    localStorage.setItem('lang', lang);
    setLang(lang);
}



